(function () {
    "use strict";

    angular
        .module("app")
        .component("certificateOfAnalysis", {
            templateUrl: "src/app/reports/certificateOfAnalysisReport/certificate-of-analysis.html",
            controller: certificateOfAnalysisCtrl
        });


    function certificateOfAnalysisCtrl($window, reportService) {

        const $ctrl = this;

        $ctrl.model = {
            lotNo: "",
            notFound: false
        };

        $ctrl.ui = {
            busy: false
        }

        $ctrl.clear = () => {
            $ctrl.model.lotNo = "";
            $ctrl.ui.busy = false;
            $ctrl.model.notFound = false;
        }

        $ctrl.open = () => {
            $ctrl.ui.busy = true;
            $ctrl.model.notFound = false;
            //$window.ga("send", "event", "CertOfAnalysis", "certOfAnalysisFromReprotsClicked");
            reportService.getCertificateOfAnalysisRpt($ctrl.model.lotNo)
                .catch(() => { $ctrl.model.notFound = true; })
                .finally(() => { $ctrl.ui.busy = false; });
        }
    }

    certificateOfAnalysisCtrl.$inject = ["$window", "reportService"];

})()